import { motion } from "framer-motion";
import { FEATURES } from "../../lib/data";
import { useLanguage } from "../../lib/i18n";

const EASE = [0.16, 1, 0.3, 1];

const FeatureCard = ({ feature, index, t }) => {
  const Icon = feature.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: EASE, delay: (index % 3) * 0.08 }}
      className="group relative rounded-3xl border border-white/[0.06] bg-[#0A101F] p-8 md:p-10 overflow-hidden hover:border-white/[0.15] hover:-translate-y-1.5 transition-[transform,border-color] duration-500"
      data-testid={`feature-card-${feature.id}`}
    >
      <div className="absolute -top-24 -right-24 w-56 h-56 bg-blue-500/10 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
      <span className="font-head text-xs tracking-[0.3em] text-slate-600">{feature.num}</span>
      <div className="mt-6 mb-6 relative w-14 h-14 flex items-center justify-center">
        <div className="absolute inset-0 bg-blue-500/20 blur-xl rounded-full" />
        <div className="relative w-14 h-14 rounded-2xl bg-blue-500/10 border border-blue-400/20 flex items-center justify-center text-blue-400 group-hover:scale-110 transition-transform duration-500">
          <Icon size={24} strokeWidth={1.8} />
        </div>
      </div>
      <h3 className="font-head text-2xl md:text-[1.7rem] tracking-tight leading-tight mb-3">
        {t(`features.items.${feature.id}.title`)}
      </h3>
      <p className="text-slate-400 leading-relaxed">{t(`features.items.${feature.id}.desc`)}</p>
    </motion.div>
  );
};

export const Features = () => {
  const { t } = useLanguage();
  return (
    <section id="features" className="relative py-24 md:py-36" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16 md:mb-20">
          <motion.span initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="text-xs uppercase tracking-[0.2em] text-blue-400 font-bold">
            {t("features.label")}
          </motion.span>
          <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, ease: EASE }} className="font-head font-semibold text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight mt-4">
            {t("features.title")}
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {FEATURES.map((f, i) => (
            <FeatureCard key={f.id} feature={f} index={i} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
};
